/**
 * bz-care-guides-library.js: behaviour for snippets/bz-care-guides-library.liquid:
 * search filtering, group filters, visible-count, and the care-guide modal. Loaded with defer.
 */
(function(){
  // External defer script: find the wrapper directly (was document.currentScript.closest(...)).
  var root = document.querySelector('[data-bz-care-guides]');
  if (!root) return;

  var input = root.querySelector('[data-care-search-input]');
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-care-card]'));
  var grid = root.querySelector('[data-care-grid]');
  var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-care-group-filter]'));
  var spiceButtons = Array.prototype.slice.call(root.querySelectorAll('[data-care-spice-filter]'));
  var habitatButtons = Array.prototype.slice.call(root.querySelectorAll('[data-care-habitat-filter]'));
  var sortButtons = Array.prototype.slice.call(root.querySelectorAll('[data-care-sort]'));
  var sortWrap = root.querySelector('[data-care-sort-wrap]');
  var sortTrigger = root.querySelector('[data-care-sort-trigger]');
  var sortPanel = root.querySelector('[data-care-sort-panel]');
  var sortCurrent = root.querySelector('[data-care-sort-current]');
  var suggestions = Array.prototype.slice.call(root.querySelectorAll('[data-care-search-suggestion]'));
  var resetButtons = Array.prototype.slice.call(root.querySelectorAll('[data-care-reset]'));
  var counts = Array.prototype.slice.call(root.querySelectorAll('[data-care-visible-count]'));
  var activeGroupLabels = Array.prototype.slice.call(root.querySelectorAll('[data-care-active-group-label]'));
  var empty = root.querySelector('[data-care-empty]');
  var widened = root.querySelector('[data-care-widened]');
  var modal = root.querySelector('[data-care-modal]');
  var modalPanel = modal && modal.querySelector('.bz-care-modal__panel');
  var modalContent = root.querySelector('[data-care-modal-content]');
  var modalLabel = root.querySelector('[data-care-modal-label]');
  var modalTitle = root.querySelector('[data-care-modal-title]');
  var modalSpecies = root.querySelector('[data-care-modal-species]');
  var modalDifficulty = root.querySelector('[data-care-modal-difficulty]');
  var modalHandling = root.querySelector('[data-care-modal-handling]');
  var modalBuddy = root.querySelector('[data-care-modal-buddy]');
  var versionTabs = Array.prototype.slice.call(root.querySelectorAll('[data-care-version-tab]'));
  var currentDownload = root.querySelector('[data-care-download-current]');
  var lastFocus = null;
  var activeGroup = 'all';
  var activeSpice = 'all';
  var activeHabitats = [];
  var activeSort = 'az';
  var mobileLayout = window.matchMedia ? window.matchMedia('(max-width: 900px)') : null;
  var currentSlug = '';
  var defaultVersion = 'advanced';
  var libraryDocumentTitle = document.title;
  var savedLibraryScroll = null;
  var savedLibraryTarget = '';
  var savedLibraryTargetTop = null;
  var stopLibraryRestore = null;
  var libraryReturnLoaded = false;
  /*
    The hub's own URL, captured before openGuide() starts rewriting the address bar.
    Once the reader replaces the path with a guide URL, window.location is no longer the
    library, so closing has nothing left to derive the way back from. ?group= is kept
    deliberately: that is the active filter, and closing the reader should not clear it.
  */
  var libraryUrl = (function(){
    try {
      var u = new URL(window.location.href);
      u.searchParams.delete('guide');
      u.searchParams.delete('version');
      u.searchParams.delete('download');
      u.hash = '';
      return u.pathname + u.search;
    } catch (_) {
      return window.location.pathname;
    }
  })();
  var currentVersion = defaultVersion;

  function keyify(value){
    return String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function guideDocumentTitle(meta){
    var title = String(meta && meta.title || '').trim();
    var species = String(meta && meta.species || '').trim();
    if (!title) return libraryDocumentTitle;

    // Match snippets/meta-tags.liquid exactly: include the scientific name when
    // it fits, otherwise keep the canonical guide title at about 70 characters.
    var seoTitle = title + ' Care Guide | Big Z';
    var titleWithSpecies = title + (species ? ' (' + species + ')' : '') + ' Care Guide | Big Z';
    if (species && titleWithSpecies.length <= 70) seoTitle = titleWithSpecies;
    if (seoTitle.length > 70) seoTitle = title.slice(0, 57) + ' | Big Z';
    return seoTitle;
  }

  var referencesViewUrl = '/pages/references?view=references';
  var referenceHashAliases = {
    '#taxonomy-backbones': '#taxonomy-literature',
    '#conservation-trade': '#full-apa-list',
    '#myriapods-isopods': '#full-apa-list',
    '#key-revisions': '#full-apa-list'
  };

  function normalizeReferences(scope){
    scope = scope || root;

    Array.prototype.slice.call(scope.querySelectorAll('a[href^="/pages/references"]')).forEach(function(link){
      var href = link.getAttribute('href') || '';
      var hashIndex = href.indexOf('#');
      var hash = hashIndex === -1 ? '' : href.slice(hashIndex);
      hash = referenceHashAliases[hash] || hash;
      if (href.indexOf('?view=references') !== -1) {
        if (hash) link.setAttribute('href', referencesViewUrl + hash);
        return;
      }
      link.setAttribute('href', referencesViewUrl + hash);
    });

    Array.prototype.slice.call(scope.querySelectorAll('li')).forEach(function(item){
      var text = (item.textContent || '').toLowerCase();
      if (text.indexOf('top references:') === -1 && text.indexOf('full apa 7 list:') === -1) return;
      item.innerHTML = 'Sources: the full Big Z APA 7 reference list lives at <a href="' + referencesViewUrl + '">References</a>.';
    });
  }

  function normalizeSearchText(value){
    var text = String(value || '').toLowerCase();
    if (text.normalize) text = text.normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
    return text
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9.%]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function searchTokens(value){
    return normalizeSearchText(value).split(' ').filter(Boolean);
  }

  var ALIASES = {
    t: ['tarantula', 'tarantulas'],
    ts: ['tarantula', 'tarantulas'],
    scorp: ['scorpion', 'scorpions'],
    scorps: ['scorpion', 'scorpions'],
    pedes: ['centipede', 'centipedes', 'millipede', 'millipedes'],
    humid: ['humid', 'humidity', 'moist', 'moisture'],
    moist: ['moist', 'moisture', 'humid', 'humidity'],
    dry: ['dry', 'arid', 'low humidity'],
    beginner: ['beginner', 'starter', 'easy', 'spice 1', 'spice 2'],
    starter: ['starter', 'beginner', 'easy', 'spice 1'],
    kid: ['kid', 'child', 'family', 'spice 1'],
    safe: ['safe', 'friendly', 'spice 1']
  };

  /*
    Spelling tolerance.

    Customers do not type "Caribena versicolor". They type "versicolour", "pinktoe",
    "tarantual", "milipede", "scorpian". Three layers handle that, cheapest first:

      1. substring, as before
      2. substring against the same text with spaces removed, so "pinktoe" finds
         "pink toe" and "pink toe" still finds "pinktoe"
      3. edit distance against the library's own vocabulary

    Layer 3 runs only when a token matches nothing anywhere, and it corrects the token
    once against a vocabulary built from every card, rather than fuzzy-matching each of
    the 174 cards separately. Corrections are cached, so a given typo costs one pass.
  */
  var vocab = null;
  var correctionCache = {};

  function buildVocab(){
    if (vocab) return vocab;
    var seen = Object.create(null);
    cards.forEach(function(card){
      /* Normalized, not raw: the attribute still carries punctuation and capitals. */
      var text = card.__bzText;
      if (text === undefined){
        text = normalizeSearchText(card.getAttribute('data-care-search') || '');
        card.__bzText = text;
        card.__bzSquashed = text.replace(/ /g, '');
      }
      var words = text.split(' ');
      for (var i = 0; i < words.length; i++){
        var w = words[i];
        if (w.length > 3) seen[w] = true;
      }
    });
    vocab = Object.keys(seen);
    return vocab;
  }

  /* Damerau-Levenshtein, abandoned as soon as the row cannot beat `max`. */
  function editDistance(a, b, max){
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var prev2 = [], prev = [], curr = [], i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++){
      curr[0] = i;
      var best = curr[0];
      for (j = 1; j <= b.length; j++){
        var cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        curr[j] = Math.min(curr[j - 1] + 1, prev[j] + 1, prev[j - 1] + cost);
        if (i > 1 && j > 1 && a.charAt(i - 1) === b.charAt(j - 2) && a.charAt(i - 2) === b.charAt(j - 1)){
          curr[j] = Math.min(curr[j], prev2[j - 2] + 1);
        }
        if (curr[j] < best) best = curr[j];
      }
      if (best > max) return max + 1;
      prev2 = prev.slice();
      prev = curr.slice();
    }
    return prev[b.length];
  }

  /* How wrong a word is allowed to be. Short words stay strict or everything matches. */
  function fuzzBudget(token){
    if (token.length < 5) return 0;
    if (token.length < 7) return 1;
    return 2;
  }

  function correctToken(token){
    if (correctionCache[token]) return correctionCache[token];
    var budget = fuzzBudget(token);
    var out = [];
    if (budget > 0){
      var words = buildVocab();
      var best = budget + 1;
      for (var i = 0; i < words.length; i++){
        var d = editDistance(token, words[i], budget);
        if (d <= budget){
          if (d < best){ best = d; out = [words[i]]; }
          else if (d === best) out.push(words[i]);
        }
      }
    }
    correctionCache[token] = out;
    return out;
  }

  function tokenMatches(text, squashed, token){
    var options = ALIASES[token] || [token];
    var i;
    for (i = 0; i < options.length; i++){
      if (text.indexOf(options[i]) !== -1) return true;
    }
    /* Compound-word forms. Guarded to 5+ characters so short tokens cannot bridge words. */
    if (token.length >= 5 && squashed.indexOf(token.replace(/ /g, '')) !== -1) return true;
    var fixed = correctToken(token);
    for (i = 0; i < fixed.length; i++){
      if (text.indexOf(fixed[i]) !== -1) return true;
    }
    return false;
  }

  function compareText(a, b){
    return String(a || '').localeCompare(String(b || ''), undefined, { sensitivity: 'base' });
  }

  function normalizeSort(sort){
    if (sort === 'spice') return 'spice-asc';
    if (sort === 'lane') return 'az';
    return ['az', 'za', 'spice-asc', 'spice-desc'].indexOf(sort) !== -1 ? sort : 'az';
  }

  function sortCards(){
    if (!grid) return;
    cards.sort(function(a, b){
      var titleOrder = compareText(a.getAttribute('data-care-title'), b.getAttribute('data-care-title'));
      if (activeSort === 'za') return titleOrder * -1;
      if (activeSort === 'spice-asc' || activeSort === 'spice-desc') {
        var aSpice = parseInt(a.getAttribute('data-spice'), 10);
        var bSpice = parseInt(b.getAttribute('data-spice'), 10);
        var aMissing = !isFinite(aSpice);
        var bMissing = !isFinite(bSpice);
        if (aMissing !== bMissing) return aMissing ? 1 : -1;
        if (!aMissing && aSpice !== bSpice) {
          return activeSort === 'spice-desc' ? bSpice - aSpice : aSpice - bSpice;
        }
      }
      return titleOrder;
    });
    cards.forEach(function(card){ grid.appendChild(card); });
  }

  function setActiveSort(sort){
    activeSort = normalizeSort(sort);
    var activeOption = null;
    sortButtons.forEach(function(btn){
      var isActive = btn.getAttribute('data-care-sort') === activeSort;
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
      if (isActive) activeOption = btn;
    });
    if (sortCurrent && activeOption) {
      sortCurrent.textContent = activeOption.getAttribute('data-label') || activeOption.textContent.trim();
    }
  }

  function setSortMenuOpen(open, returnFocus){
    if (!sortTrigger || !sortPanel) return;
    sortPanel.hidden = !open;
    sortTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      var selected = sortPanel.querySelector('[data-care-sort][aria-selected="true"]') || sortButtons[0];
      if (selected) selected.focus();
    } else if (returnFocus) {
      sortTrigger.focus();
    }
  }

  function setActiveButton(group){
    activeGroup = group || 'all';
    buttons.forEach(function(btn){
      var isActive = btn.getAttribute('data-care-group-filter') === activeGroup;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
    updateActiveFilterLabel();
  }

  function setActiveSpice(spice){
    activeSpice = spice || 'all';
    spiceButtons.forEach(function(btn){
      var isActive = btn.getAttribute('data-care-spice-filter') === activeSpice;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function validHabitats(habitats){
    if (!Array.isArray(habitats)) habitats = habitats ? [habitats] : [];
    var available = habitatButtons.map(function(btn){ return btn.getAttribute('data-care-habitat-filter'); });
    return habitats.reduce(function(result, habitat){
      habitat = keyify(habitat);
      if (available.indexOf(habitat) !== -1 && result.indexOf(habitat) === -1) result.push(habitat);
      return result;
    }, []);
  }

  function setActiveHabitats(habitats){
    activeHabitats = validHabitats(habitats);
    habitatButtons.forEach(function(btn){
      var isActive = activeHabitats.indexOf(btn.getAttribute('data-care-habitat-filter')) !== -1;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
    updateActiveFilterLabel();
  }

  function enforceMobileDefaults(){
    if (!mobileLayout || !mobileLayout.matches) return;
    setActiveSpice('all');
  }

  function cardText(card){
    if (card.__bzText === undefined){
      card.__bzText = normalizeSearchText(card.getAttribute('data-care-search') || '');
      card.__bzSquashed = card.__bzText.replace(/ /g, '');
    }
    return card.__bzText;
  }

  /* A card answers a filter by its animal or by its shelf, so "Industry Staples" is a tag
     a guide carries rather than a drawer it is locked inside. */
  function cardInGroup(card, group){
    return group === 'all'
      || card.getAttribute('data-care-group') === group
      || card.getAttribute('data-care-shelf') === group;
  }

  function cardInSpice(card, spice){
    return spice === 'all' || card.getAttribute('data-spice') === spice;
  }

  function cardInHabitats(card, habitats){
    if (!habitats || !habitats.length) return true;
    var cardHabitats = ' ' + String(card.getAttribute('data-care-habitat') || '').trim() + ' ';
    return habitats.some(function(habitat){
      return cardHabitats.indexOf(' ' + habitat + ' ') !== -1;
    });
  }

  function filterLabel(button){
    if (!button) return '';
    var label = button.querySelector('[data-care-filter-label]');
    return ((label ? label.textContent : button.textContent) || '').trim();
  }

  function groupLabel(group){
    for (var i = 0; i < buttons.length; i++){
      if (buttons[i].getAttribute('data-care-group-filter') === group){
        return filterLabel(buttons[i]) || group;
      }
    }
    return group;
  }

  function habitatLabel(habitat){
    for (var i = 0; i < habitatButtons.length; i++){
      if (habitatButtons[i].getAttribute('data-care-habitat-filter') === habitat){
        return filterLabel(habitatButtons[i]) || habitat;
      }
    }
    return habitat;
  }

  function updateActiveFilterLabel(){
    var labels = [];
    if (activeGroup !== 'all') labels.push(groupLabel(activeGroup));
    activeHabitats.forEach(function(habitat){ labels.push(habitatLabel(habitat)); });
    var summary = labels.length ? labels.join(' / ') : 'All animal categories';
    activeGroupLabels.forEach(function(label){ label.textContent = summary; });
  }

  /* Facet counts show how many guides match each option after the other filter families.
     Setup styles are ORed within their family, because a mixed fossorial/terrestrial guide
     truthfully belongs under either tag. */
  function updateFacetCounts(){
    buttons.forEach(function(btn){
      var group = btn.getAttribute('data-care-group-filter') || 'all';
      var total = cards.filter(function(card){
        return card.__bzHit && cardInGroup(card, group) && cardInSpice(card, activeSpice) && cardInHabitats(card, activeHabitats);
      }).length;
      var count = btn.querySelector('[data-care-group-count]');
      var label = filterLabel(btn) || group;
      if (count) count.textContent = String(total);
      btn.setAttribute('aria-label', label + ', ' + total + (total === 1 ? ' guide' : ' guides'));
    });

    spiceButtons.forEach(function(btn){
      var spice = btn.getAttribute('data-care-spice-filter') || 'all';
      var total = cards.filter(function(card){
        return card.__bzHit && cardInGroup(card, activeGroup) && cardInSpice(card, spice) && cardInHabitats(card, activeHabitats);
      }).length;
      var count = btn.querySelector('[data-care-spice-count]');
      var label = filterLabel(btn) || ('Spice ' + spice);
      if (count) count.textContent = String(total);
      btn.setAttribute('aria-label', label + ', ' + total + (total === 1 ? ' guide' : ' guides'));
    });

    habitatButtons.forEach(function(btn){
      var habitat = btn.getAttribute('data-care-habitat-filter');
      var total = cards.filter(function(card){
        return card.__bzHit && cardInGroup(card, activeGroup) && cardInSpice(card, activeSpice) && cardInHabitats(card, [habitat]);
      }).length;
      var count = btn.querySelector('[data-care-habitat-count]');
      var label = filterLabel(btn) || habitat;
      if (count) count.textContent = String(total);
      btn.setAttribute('aria-label', label + ', ' + total + (total === 1 ? ' guide' : ' guides'));
    });
  }

  function filtersAreActive(){
    return !!((input && String(input.value || '').trim()) || activeGroup !== 'all' || activeSpice !== 'all' || activeHabitats.length);
  }

  function updateResetButtons(){
    var show = filtersAreActive();
    resetButtons.forEach(function(btn){ btn.hidden = !show; });
  }

  function resetResultsScroll(){
    if (mobileLayout && mobileLayout.matches && grid) grid.scrollTop = 0;
  }

  function clearFilterQuery(){
    try {
      var current = new URL(window.location.href);
      if (current.searchParams.has('group') && window.history && window.history.replaceState) {
        current.searchParams.delete('group');
        window.history.replaceState(window.history.state, '', current.pathname + current.search + current.hash);
      }

      var hub = new URL(libraryUrl, window.location.origin);
      hub.searchParams.delete('group');
      libraryUrl = hub.pathname + hub.search;
    } catch (_) {}
  }

  function clearFilters(){
    if (input) input.value = '';
    setActiveButton('all');
    setActiveSpice('all');
    setActiveHabitats([]);
    clearFilterQuery();
    applyFilters();
    resetResultsScroll();
  }

  function applyFilters(){
    var tokens = searchTokens(input ? input.value : '');
    var anyHit = false;
    cards.forEach(function(card){
      var text = cardText(card);
      card.__bzHit = !tokens.length || tokens.every(function(token){
        return tokenMatches(text, card.__bzSquashed, token);
      });
      if (card.__bzHit) anyHit = true;
    });

    /*
      Search used to be ANDed with the open filter, so looking for a millipede while standing
      in the scorpion drawer reported zero and read as "the shop has no guide for this". If a
      search matches nothing in the active filter but matches elsewhere, widen to All and say
      so. The filter buttons update with it, so the change is visible rather than silent.
    */
    var widenedFrom = '';
    if (tokens.length && anyHit && (activeGroup !== 'all' || activeSpice !== 'all' || activeHabitats.length)){
      var hitInFilters = cards.some(function(card){
        return card.__bzHit && cardInGroup(card, activeGroup) && cardInSpice(card, activeSpice) && cardInHabitats(card, activeHabitats);
      });
      if (!hitInFilters){
        var widenedLabels = [];
        if (activeGroup !== 'all') widenedLabels.push(groupLabel(activeGroup));
        if (activeSpice !== 'all') widenedLabels.push('Spice ' + activeSpice);
        activeHabitats.forEach(function(habitat){ widenedLabels.push(habitatLabel(habitat)); });
        widenedFrom = widenedLabels.join(' + ');
        setActiveButton('all');
        setActiveSpice('all');
        setActiveHabitats([]);
      }
    }

    var visible = 0;
    cards.forEach(function(card){
      var show = card.__bzHit && cardInGroup(card, activeGroup) && cardInSpice(card, activeSpice) && cardInHabitats(card, activeHabitats);
      card.hidden = !show;
      if (show) visible += 1;
    });

    updateFacetCounts();
    updateResetButtons();
    counts.forEach(function(count){ count.textContent = String(visible); });
    if (empty) empty.hidden = visible !== 0;
    if (widened){
      if (widenedFrom){
        widened.innerHTML = 'No matches in <b>' + widenedFrom + '</b>. Showing matching guides across the full library.';
        widened.hidden = false;
      } else {
        widened.hidden = true;
      }
    }
  }

  function savedLibraryState(){
    try {
      var state = window.history && window.history.state;
      var saved = state && state.bzCareGuides;
      if (!saved || saved.path !== window.location.pathname + window.location.search) return null;
      return saved;
    } catch (_) {
      return null;
    }
  }

  function resetLibraryStateMemory(){
    savedLibraryScroll = null;
    savedLibraryTarget = '';
    savedLibraryTargetTop = null;
  }

  function consumeSavedLibraryState(){
    try {
      if (!window.history || !window.history.replaceState) return;
      var state = window.history.state && typeof window.history.state === 'object'
        ? Object.assign({}, window.history.state)
        : {};
      delete state.bzCareGuides;
      window.history.replaceState(state, '', window.location.href);
    } catch (_) {}
  }

  function saveLibraryState(guideLink){
    try {
      if (!window.history || !window.history.replaceState) return;
      var state = window.history.state && typeof window.history.state === 'object'
        ? Object.assign({}, window.history.state)
        : {};
      var card = guideLink && guideLink.closest ? guideLink.closest('[data-care-card]') : null;
      state.bzCareGuides = {
        path: window.location.pathname + window.location.search,
        search: input ? input.value : '',
        group: activeGroup,
        spice: activeSpice,
        habitats: activeHabitats.slice(),
        sort: activeSort,
        scrollY: window.scrollY || window.pageYOffset || 0,
        target: guideLink ? guideLink.getAttribute('href') || '' : '',
        targetTop: card ? card.getBoundingClientRect().top : null
      };
      window.history.replaceState(state, '', window.location.href);
      if (stopLibraryRestore) stopLibraryRestore();
      resetLibraryStateMemory();
      libraryReturnLoaded = false;
    } catch (_) {}
  }

  function loadSavedLibraryState(){
    resetLibraryStateMemory();
    var saved = savedLibraryState();
    if (!saved) return false;
    if (input && typeof saved.search === 'string') input.value = saved.search;
    if (saved.group && buttons.some(function(btn){ return btn.getAttribute('data-care-group-filter') === saved.group; })) {
      setActiveButton(saved.group);
    }
    if (saved.spice && spiceButtons.some(function(btn){ return btn.getAttribute('data-care-spice-filter') === saved.spice; })) {
      setActiveSpice(saved.spice);
    }
    var savedHabitats = Array.isArray(saved.habitats) ? saved.habitats : (saved.habitat ? [saved.habitat] : []);
    setActiveHabitats(savedHabitats);
    var savedSort = normalizeSort(saved.sort);
    if (sortButtons.some(function(btn){ return btn.getAttribute('data-care-sort') === savedSort; })) {
      setActiveSort(savedSort);
    }
    var scrollY = Number(saved.scrollY);
    if (isFinite(scrollY) && scrollY >= 0) savedLibraryScroll = scrollY;
    if (typeof saved.target === 'string') savedLibraryTarget = saved.target;
    if (saved.targetTop !== null && saved.targetTop !== '') {
      var targetTop = Number(saved.targetTop);
      if (isFinite(targetTop)) savedLibraryTargetTop = targetTop;
    }
    consumeSavedLibraryState();
    return true;
  }

  function restoreLibraryScroll(){
    if (typeof savedLibraryScroll !== 'number' || !isFinite(savedLibraryScroll)) return;
    if (stopLibraryRestore) stopLibraryRestore();

    var stopped = false;
    var observer = null;
    var timer = null;
    var stopEvents = ['wheel', 'touchstart', 'pointerdown', 'keydown'];

    function findSavedCard(){
      if (!savedLibraryTarget) return null;
      var links = root.querySelectorAll('.bz-care-card [data-care-guide-link][href]');
      for (var i = 0; i < links.length; i++){
        if (links[i].getAttribute('href') === savedLibraryTarget) {
          return links[i].closest('[data-care-card]');
        }
      }
      return null;
    }

    function align(){
      if (stopped) return;
      var card = findSavedCard();
      var top = savedLibraryScroll;
      if (card && typeof savedLibraryTargetTop === 'number' && isFinite(savedLibraryTargetTop)) {
        var delta = card.getBoundingClientRect().top - savedLibraryTargetTop;
        if (Math.abs(delta) <= 1) return;
        top = (window.scrollY || window.pageYOffset || 0) + delta;
      }
      /* The theme opts into smooth scrolling globally. Restoration must be immediate or
         repeated grid-resize corrections continually restart the smooth animation. */
      try {
        window.scrollTo({ left: 0, top: Math.max(0, top), behavior: 'instant' });
      } catch (_) {
        window.scrollTo(0, Math.max(0, top));
      }
    }

    function stop(){
      if (stopped) return;
      stopped = true;
      if (observer) observer.disconnect();
      if (timer) window.clearTimeout(timer);
      stopEvents.forEach(function(name){ window.removeEventListener(name, stop); });
      if (stopLibraryRestore === stop) stopLibraryRestore = null;
    }

    stopLibraryRestore = stop;
    stopEvents.forEach(function(name){ window.addEventListener(name, stop, { passive: true }); });

    window.requestAnimationFrame(function(){
      window.requestAnimationFrame(align);
    });

    /* Product photos and storefront fonts can finish laying out after pageshow. Keep the
       same card anchored briefly as the grid grows, then get out of the visitor's way. */
    if (window.ResizeObserver && grid) {
      observer = new ResizeObserver(function(){ window.requestAnimationFrame(align); });
      observer.observe(grid);
    } else {
      [250, 750, 1500, 3000].forEach(function(delay){ window.setTimeout(align, delay); });
    }
    timer = window.setTimeout(stop, 4000);
  }

  resetButtons.forEach(function(btn){
    btn.addEventListener('click', function(){
      if (stopLibraryRestore) stopLibraryRestore();
      clearFilters();
    });
  });

  buttons.forEach(function(btn){
    btn.addEventListener('click', function(){
      if (stopLibraryRestore) stopLibraryRestore();
      setActiveButton(btn.getAttribute('data-care-group-filter'));
      applyFilters();
      resetResultsScroll();
    });
  });

  spiceButtons.forEach(function(btn){
    btn.addEventListener('click', function(){
      if (stopLibraryRestore) stopLibraryRestore();
      var spice = btn.getAttribute('data-care-spice-filter');
      setActiveSpice(activeSpice === spice ? 'all' : spice);
      applyFilters();
      resetResultsScroll();
    });
  });

  habitatButtons.forEach(function(btn){
    btn.addEventListener('click', function(){
      if (stopLibraryRestore) stopLibraryRestore();
      var habitat = btn.getAttribute('data-care-habitat-filter');
      var nextHabitats = activeHabitats.slice();
      var activeIndex = nextHabitats.indexOf(habitat);
      if (activeIndex === -1) nextHabitats.push(habitat);
      else nextHabitats.splice(activeIndex, 1);
      setActiveHabitats(nextHabitats);
      applyFilters();
      resetResultsScroll();
    });
  });

  if (sortTrigger && sortPanel) {
    sortTrigger.addEventListener('click', function(event){
      event.stopPropagation();
      setSortMenuOpen(sortPanel.hidden, false);
    });
    document.addEventListener('click', function(event){
      if (!sortPanel.hidden && (!sortWrap || !sortWrap.contains(event.target))) setSortMenuOpen(false, false);
    });
    document.addEventListener('keydown', function(event){
      if (event.key === 'Escape' && !sortPanel.hidden) {
        setSortMenuOpen(false, true);
      }
    });
    sortPanel.addEventListener('keydown', function(event){
      var options = sortButtons.filter(function(option){
        return !option.disabled && option.getAttribute('aria-disabled') !== 'true';
      });
      if (!options.length) return;
      var currentIndex = options.indexOf(document.activeElement);
      var nextIndex = currentIndex;
      if (event.key === 'ArrowDown') nextIndex = currentIndex < options.length - 1 ? currentIndex + 1 : 0;
      else if (event.key === 'ArrowUp') nextIndex = currentIndex > 0 ? currentIndex - 1 : options.length - 1;
      else if (event.key === 'Home') nextIndex = 0;
      else if (event.key === 'End') nextIndex = options.length - 1;
      else if (event.key === 'Tab') {
        window.setTimeout(function(){
          if (!sortWrap || !sortWrap.contains(document.activeElement)) setSortMenuOpen(false, false);
        }, 0);
        return;
      } else {
        return;
      }
      event.preventDefault();
      options[nextIndex].focus();
    });
  }

  sortButtons.forEach(function(btn){
    btn.addEventListener('click', function(event){
      event.stopPropagation();
      if (stopLibraryRestore) stopLibraryRestore();
      setActiveSort(btn.getAttribute('data-care-sort'));
      sortCards();
      resetResultsScroll();
      setSortMenuOpen(false, true);
    });
  });

  suggestions.forEach(function(btn){
    btn.addEventListener('click', function(){
      if (!input) return;
      if (stopLibraryRestore) stopLibraryRestore();
      input.value = btn.getAttribute('data-care-search-suggestion') || '';
      applyFilters();
      resetResultsScroll();
      input.focus();
    });
  });

  if (input) {
    input.addEventListener('input', function(){
      if (stopLibraryRestore) stopLibraryRestore();
      applyFilters();
      resetResultsScroll();
    });
  }

  normalizeReferences(root);

  function findTemplate(slug, version){
    return root.querySelector('[data-care-template][data-care-version="' + version + '"][data-care-slug="' + slug + '"]');
  }

  /* ---------------------------------------------------------------------
     On-demand guide loading.

     This page used to inline all 302 guide bodies (151 guides x two versions)
     as hidden <template> blocks, which cost every visitor 2.56 MB before they
     had opened anything. The bodies now come from /pages/care-guides/<slug>,
     which renders the same two templates, and are cached per slug for the life
     of the page. Opening a guide costs one fetch; opening it again costs none.
     --------------------------------------------------------------------- */

  var templateStore = root.querySelector('[data-care-template-store]') || root;
  var templateCache = Object.create(null); // slug -> Promise<boolean>

  function guideUrl(slug){
    return '/pages/care-guides/' + encodeURIComponent(slug);
  }

  /*
    Confirmation for the roster's Share button.

    The word on the button belongs to the snippet, so it is read once and stashed on the
    element rather than reset to a hard-coded 'Share' - which is what the previous version
    did, and which quietly renamed the control if the label was ever changed in Liquid.

    Reading it once also survives a double click. Without the stash, the second click reads
    the label mid-confirmation, saves 'Copied!' as the original, and the button keeps that
    word for the rest of the session.

    The text goes into [data-care-share-label] when the button has one, so anything else
    inside the button survives the swap.
  */
  function flagShareCopied(sharer){
    var label = sharer.querySelector('[data-care-share-label]') || sharer;
    if (!sharer.hasAttribute('data-care-share-text')) {
      sharer.setAttribute('data-care-share-text', label.textContent);
    }
    if (sharer.bzShareTimer) window.clearTimeout(sharer.bzShareTimer);
    label.textContent = 'Copied!';
    sharer.classList.add('is-copied');
    sharer.bzShareTimer = window.setTimeout(function(){
      label.textContent = sharer.getAttribute('data-care-share-text');
      sharer.classList.remove('is-copied');
      sharer.bzShareTimer = 0;
    }, 1600);
  }

  function loadTemplates(slug){
    if (!slug) return Promise.resolve(false);
    if (findTemplate(slug, 'advanced') || findTemplate(slug, 'simple')) return Promise.resolve(true);
    if (templateCache[slug]) return templateCache[slug];

    templateCache[slug] = fetch(guideUrl(slug), { credentials: 'same-origin' })
      .then(function(res){
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function(html){
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var found = parsed.querySelectorAll('[data-care-template][data-care-slug="' + slug + '"]');
        if (!found.length) throw new Error('no templates in guide page');
        Array.prototype.forEach.call(found, function(tpl){
          templateStore.appendChild(document.importNode(tpl, true));
        });
        return true;
      })
      .catch(function(err){
        // Let a later attempt retry rather than caching the failure forever.
        delete templateCache[slug];
        if (window.console && console.warn) console.warn('[care-guides] could not load ' + slug, err);
        return false;
      });

    return templateCache[slug];
  }

  function findCard(slug){
    return root.querySelector('[data-care-card][id="guide-' + slug + '"]');
  }

  function getGuideMeta(slug){
    var card = findCard(slug);
    return {
      title: card ? card.getAttribute('data-care-title') || 'Care guide' : 'Care guide',
      species: card ? card.getAttribute('data-care-species') || '' : '',
      difficulty: card ? card.getAttribute('data-care-difficulty') || '' : '',
      handling: card ? card.getAttribute('data-care-handling') || '' : ''
      // `buddy` was collected here and then discarded: bz-care-guide-pdf.js reads
      // only meta.title and meta.species, and bz-care-guide-page.js passes only
      // those two. data-care-buddy was removed from the roster card 2026-08-23.
    };
  }

  function downloadAdvanced(slug){
    // The advanced body may not be in the DOM yet, so fetch it first. The PDF
    // walker itself is unchanged and still reads from the same template.
    if (!findTemplate(slug, 'advanced')) {
      loadTemplates(slug).then(function(ok){
        if (ok) writePdf(slug);
      });
      return;
    }
    writePdf(slug);
  }

  function writePdf(slug){
    if (!window.BZCareGuidePdf) return;
    window.BZCareGuidePdf.download({
      root: root,
      slug: slug,
      meta: getGuideMeta(slug),
      normalize: normalizeReferences
    });
  }

  function renderVersion(version){
    var template = findTemplate(currentSlug, version);
    if (!template && version !== 'simple') {
      version = 'simple';
      template = findTemplate(currentSlug, version);
    }
    if (!template) {
      // Nothing to show and the fetch failed. Send them to the real page rather
      // than leaving an empty modal open.
      modalContent.innerHTML = '<p class="bz-care-modal__fallback">This guide could not be loaded. '
        + '<a href="' + guideUrl(currentSlug) + '">Open the full guide page</a>.</p>';
      return;
    }

    modalContent.innerHTML = '';
    modalContent.appendChild(template.content.cloneNode(true));
    normalizeReferences(modalContent);
    currentVersion = version;
    if (modalLabel) modalLabel.textContent = version === 'advanced' ? 'Advanced Care Guide' : 'Simple Care Guide';
    versionTabs.forEach(function(tab){
      var isActive = tab.getAttribute('data-care-version-tab') === version;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.setAttribute('tabindex', isActive ? '0' : '-1');
      if (isActive && modalContent) modalContent.setAttribute('aria-labelledby', tab.id);
    });
    if (modalContent) modalContent.scrollTop = 0;
  }

  function setActiveVersion(version){
    version = version || defaultVersion;
    if (findTemplate(currentSlug, version) || findTemplate(currentSlug, 'simple')) {
      renderVersion(version);
      return;
    }
    var slugAtRequest = currentSlug;
    modalContent.innerHTML = '<p class="bz-care-modal__loading" role="status">Loading guide...</p>';
    loadTemplates(slugAtRequest).then(function(){
      // The reader may have closed the modal or opened a different guide while
      // this was in flight. Only paint if it is still the one they asked for.
      if (currentSlug !== slugAtRequest) return;
      renderVersion(version);
    });
  }

  function openGuide(slug, version){
    if (!modal || !modalContent || !slug) return;
    currentSlug = slug;
    lastFocus = document.activeElement;

    var meta = getGuideMeta(slug);
    if (modalTitle) modalTitle.textContent = meta.title;
    if (modalSpecies) modalSpecies.textContent = meta.species;
    if (modalDifficulty) modalDifficulty.textContent = meta.difficulty;
    if (modalHandling) modalHandling.textContent = meta.handling;
    if (modalBuddy) modalBuddy.textContent = meta.buddy;
    if (currentDownload) currentDownload.setAttribute('data-care-slug', slug);
    if (meta.title) document.title = guideDocumentTitle(meta);

    setActiveVersion(version || defaultVersion);
    modal.hidden = false;
    document.body.classList.add('bz-care-modal-open');
    if (modalPanel) {
      try { modalPanel.focus(); } catch (_) {}
    }

    /*
      Address bar shows the guide's OWN url, not the hub plus a #fragment.

      A fragment is never sent to the server, so /pages/care-guides#guide-<slug> is simply
      /pages/care-guides to Google, to analytics, and to anyone pasting the link. Every
      share and every copied address therefore credited the hub instead of the guide it
      was pointing at, while the guide's real page - server-rendered, in the sitemap, and
      separately indexable - collected nothing.

      Every guide already has that page at /pages/care-guides/<slug> and it renders the
      same body this reader is showing, so the reader now names it. Reload or copy-paste
      out of the address bar lands on the right page instead of the top of the library.

      Still replaceState, exactly as before, so the history stack and the Back button
      behave the way they always have here.

      The version is deliberately not carried into the URL any more. It only ever meant
      anything on the hub URL, which is no longer what is shown, and the guide page picks
      its version from a section setting rather than a query string - so ?version=simple
      on a guide URL would be a lie that also spawns a duplicate URL variant.
    */
    try {
      if (window.history && window.location) {
        var url = new URL(guideUrl(slug), window.location.origin);
        window.history.replaceState(window.history.state, '', url.toString());
      }
    } catch (_) {}
  }

  function closeGuide(){
    if (!modal) return;
    modal.hidden = true;
    if (modalContent) modalContent.innerHTML = '';
    document.body.classList.remove('bz-care-modal-open');
    currentSlug = '';
    document.title = libraryDocumentTitle;
    try {
      if (window.history && window.location && libraryUrl) {
        window.history.replaceState(window.history.state, '', libraryUrl);
      }
    } catch (_) {}
    if (lastFocus && typeof lastFocus.focus === 'function') {
      try { lastFocus.focus(); } catch (_) {}
    }
  }

  root.addEventListener('click', function(event){
    var tab = event.target.closest && event.target.closest('[data-care-version-tab]');
    if (tab) {
      event.preventDefault();
      setActiveVersion(tab.getAttribute('data-care-version-tab'));
      return;
    }

    var downloader = event.target.closest && event.target.closest('[data-care-download], [data-care-download-current]');
    if (downloader) {
      event.preventDefault();
      downloadAdvanced(downloader.getAttribute('data-care-slug') || currentSlug);
      return;
    }

    var sharer = event.target.closest && event.target.closest('[data-care-share]');
    if (sharer) {
      event.preventDefault();
      var slug = sharer.getAttribute('data-care-share-slug');
      if (!slug) return;
      /*
        Share copies the guide's canonical page, not the hub with a #fragment pinned to a
        card. The old string was the single worst link in the store: it read like a deep
        link, but every one of them pointed search engines and referrers at the library
        index. Same reasoning as openGuide above.
      */
      var shareUrl = window.location.origin + guideUrl(slug);
      if (navigator.clipboard && navigator.clipboard.writeText) {
        /* writeText rejects on a denied permission or a non-secure origin. The old call had
           no rejection path, so those cases threw into the console and left the customer
           with a button that looked broken. Fall through to the prompt instead. */
        navigator.clipboard.writeText(shareUrl).then(
          function(){ flagShareCopied(sharer); },
          function(){ window.prompt('Copy this guide URL:', shareUrl); }
        );
      } else {
        window.prompt('Copy this guide URL:', shareUrl);
      }
      return;
    }

    var closer = event.target.closest && event.target.closest('[data-care-close]');
    if (closer) {
      event.preventDefault();
      closeGuide();
      return;
    }

    /* Save this history entry before native card navigation. The guide-page Back control
       can then return to the same search, filter, and position even if the hub reloads. */
    var guideLink = event.target.closest && event.target.closest('.bz-care-card [data-care-guide-link][href]');
    if (
      guideLink
      && !event.defaultPrevented
      && event.button === 0
      && !event.metaKey
      && !event.ctrlKey
      && !event.shiftKey
      && !event.altKey
      && (!guideLink.target || guideLink.target === '_self')
    ) saveLibraryState(guideLink);
  });

  root.addEventListener('keydown', function(event){
    var tab = event.target.closest && event.target.closest('[data-care-version-tab]');
    if (!tab) return;

    var index = versionTabs.indexOf(tab);
    if (index === -1) return;

    var nextTab = null;
    if (event.key === 'Home') nextTab = versionTabs[0];
    if (event.key === 'End') nextTab = versionTabs[versionTabs.length - 1];
    if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      nextTab = versionTabs[(index - 1 + versionTabs.length) % versionTabs.length];
    }
    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      nextTab = versionTabs[(index + 1) % versionTabs.length];
    }
    if (!nextTab) return;

    event.preventDefault();
    setActiveVersion(nextTab.getAttribute('data-care-version-tab'));
    nextTab.focus();
  });

  document.addEventListener('keydown', function(event){
    if (event.key === 'Escape' && modal && !modal.hidden) {
      event.preventDefault();
      closeGuide();
      return;
    }

    if (event.key !== 'Tab' || !modal || modal.hidden || !modalPanel) return;
    var focusables = Array.prototype.slice.call(modalPanel.querySelectorAll('a[href], button:not([disabled]), summary, [tabindex]:not([tabindex="-1"])'))
      .filter(function(item){ return item.offsetParent !== null || item === modalPanel; });
    if (!focusables.length) return;
    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  try {
    var params = new URLSearchParams(window.location.search);
    var group = keyify(params.get('group'));
    if (group && buttons.some(function(btn){ return btn.getAttribute('data-care-group-filter') === group; })) {
      setActiveButton(group);
    }

    libraryReturnLoaded = loadSavedLibraryState();

    /*
      Back-compat only. #guide-<slug> and ?guide=<slug> are no longer produced anywhere,
      but people have them bookmarked and pasted into DMs, so they keep opening the right
      guide. Do not remove: this is the landing path for every link shared before
      2026-08-21.
    */
    var hashGuide = '';
    if (window.location.hash && window.location.hash.indexOf('#guide-') === 0) {
      hashGuide = keyify(window.location.hash.replace('#guide-', '').split('&')[0]);
    }
    var guide = keyify(params.get('guide')) || hashGuide;
    var version = keyify(params.get('version')) || defaultVersion;
    var download = keyify(params.get('download'));
    if (guide) {
      /*
        Old shared ?guide= and #guide- URLs still work, but they now migrate directly to the
        canonical full-page reader. replace() keeps the obsolete hub URL out of Back history.
      */
      if (download === 'advanced') {
        downloadAdvanced(guide);
      } else {
        var legacyTarget = guideUrl(guide);
        if (version === 'simple') legacyTarget += '#simple';
        window.location.replace(legacyTarget);
      }
    }
  } catch (_) {}

  enforceMobileDefaults();
  setActiveButton(activeGroup);
  setActiveSpice(activeSpice);
  setActiveHabitats(activeHabitats);
  setActiveSort(activeSort);
  sortCards();
  applyFilters();
  if (libraryReturnLoaded) restoreLibraryScroll();

  /* Chrome can restore form fields and its own scroll position after defer scripts run on
     a Back navigation. Re-apply our entry state once the history page is actually shown. */
  window.addEventListener('pageshow', function(){
    var loadedNow = false;
    if (!libraryReturnLoaded) {
      loadedNow = loadSavedLibraryState();
      libraryReturnLoaded = loadedNow;
    }
    enforceMobileDefaults();
    sortCards();
    applyFilters();
    if (loadedNow) restoreLibraryScroll();
  });

  if (mobileLayout) {
    var onLayoutChange = function(event){
      if (!event.matches) return;
      enforceMobileDefaults();
      sortCards();
      applyFilters();
    };
    if (mobileLayout.addEventListener) mobileLayout.addEventListener('change', onLayoutChange);
    else if (mobileLayout.addListener) mobileLayout.addListener(onLayoutChange);
  }
})();
